import { useQuery } from "@tanstack/react-query";
import ApiClient from "../../../api/ApiClient";
import { Category } from "../data/Category";

async function get(): Promise<Category[]> {
    const response = await ApiClient({ url: "categories", method: "GET" });

    if (response.status === 200) {
        return response.data;
    }
    throw new Error(response.data);
}

export function useGetCategoriesQuery() {
    return useQuery<Category[]>({
        queryKey: ["get-categories"],
        queryFn: get,
        refetchOnWindowFocus: false,
    });
}